import React from "react";
import "../Pricing.scss";
import dots from "../../images/dots.svg";
const PricingComponent = () => {
  return (
    <div id="pricing" className="PracingPage">
      <div className="pricingComponent">
        <div className="LeftPricingSection">
          <h1 className="agencyTitile">
            one simple <span className="orangeTitle">pricing</span>
          </h1>
          <div className="features">
            <p className="option1">Unlimited features</p>
            <p className="option2">Unlimited members</p>
            <p className="option3">Unlimited workflows</p>
            <p className="option4">Unlimited calendars</p>
            <p className="option5">Unlimited meeting</p>
          </div>
          <div className="signUpCont" >
            <a href="#" className="signUpButton">
              Sign Up
            </a>
          </div>
        </div>
        <div className="RightPricingSection">
          <div className="pricing">
            <h1>49€</h1>
            <p>/ client / month</p>
          </div>

          <img className="pricingImage" src={dots} alt="dots" />
        </div>
      </div>
    </div>
  );
};

export default PricingComponent;
